module.exports = __webpack_public_path__ + "static/img/m_name.c6838c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/tsz/m_name.png
// module id = vcVp
// module chunks = 7